import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Panel } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import {
  getContractChangeFile,
  getEContractFile,
  saveContractChangeForm,
  sendContractChangeSign,
} from '../../redux/actions/contract'
import { startLoading, doneLoading } from '../../utils/loading'
import CenterChangeFormForm from './CenterChangeFormForm'
import CenterChangeFormView from './CenterChangeFormView'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import CenterChangeFormInfo from './CenterChangeFormInfo'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import pathname from '../../constants/pathname'
import { downloadFileByPath } from '../../redux/actions/accountingAssetClosure'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import ConfirmWidget from '../confirm/ConfirmWidget'
import DownloadButton from '../../components/buttons/downloadButton/downloadButton'
import AppContext from '../../context/AppContext'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import AttachFilesPaperTypeForm from './AttachFilesPaperTypeForm'
import scrollToComponent from 'react-scroll-to-component'

export default function CenterChangeFormWidget(props) {
  const [section, setSection] = useState()
  const [isConfimSendSign, setIsConfimSendSign] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const { theme } = React.useContext(AppContext)
  // const [isEdit, setIsEdit] = useState(false)
  const [isRefash, setIsRefash] = useState(false)
  const [delFiles, setDelFiles] = useState([])
  const [tableSelected, setTableSelected] = useState(
    formSchema?.contractChangeAttachment?.selected || []
  )
  const [optionSelected, setOptionSelected] = useState(
    formSchema?.inputForm?.saveContractChange?.value || '1'
  )

  const history = useHistory()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  // useEffect(() => {
  //   setIsEdit(formSchema?.attachFilesPaperType?.values?.length > 0)
  // }, [formSchema])

  const handleCallService = async (request, projectVersionId, typeSelected) => {
    startLoading()
    setIsLoading(true)
    try {
      let response = await saveContractChangeForm(projectVersionId, request)
      // console.log('response', response)
      if (response?.model) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })

        if (typeSelected == '1' || typeSelected == '4') {
          history.push({
            pathname: `${pathname.proposal.overview.overviewCoworker}`,
          })
        } else {
          setFormSchema(response.model)
          setValue('contractorFile', undefined)
          scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
          onRefash()
        }
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errors?.messag || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleSendToSign = async () => {
    startLoading()
    setIsLoading(true)
    try {
      let response = await sendContractChangeSign(
        projectId,
        formSchema.contractChangeFormInfo?.contractChangeId
      )
      // console.log('response', response)
      if (response.success && response?.model) {
        setFormSchema(response.model)
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: response?.errorMessage || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errors?.messag || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDownloadFile = async () => {
    startLoading()
    setIsLoading(true)
    try {
      var file = ''
      var fileName = 'บันทึกแก้ไขเพิ่มเติมข้อตกลง.pdf'

      // if (formSchema.contractChangeFormInfo?.statusCode == 3) {
      //   file = await getEContractFile(
      //     projectId,
      //     formSchema.contractChangeFormInfo?.complatePathFile
      //   )
      // } else
      if (formSchema.contractChangeFormInfo?.pathFile) {
        file = await downloadFileByPath(formSchema.contractChangeFormInfo?.pathFile)
      } else {
        file = await getContractChangeFile(
          projectId,
          formSchema.contractChangeFormInfo?.contractChangeId
        )
      }

      previewFile(file, fileName)
    } catch (e) {
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDownloadEContractFile = async (pathFile) => {
    startLoading()
    setIsLoading(true)
    try {
      var fileName = 'บันทึกแก้ไขเพิ่มเติมข้อตกลง.pdf'

      var file = await getEContractFile(pathFile)

      downloadFile(file, fileName)
    } catch (e) {
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    //console.log('data', data)
    const formData = new FormData()

    formData.append('Id', formSchema?.contractChangeFormInfo?.id)
    formData.append('ContractChangeId', formSchema?.contractChangeFormInfo?.contractChangeId)
    formData.append('Note', data?.note || '')
    formData.append('Witness1', data?.witness1 || '')
    formData.append('Witness2', data?.witness2 || '')
    formData.append('TypeSelected', data?.saveContractChange)

    data?.reqFileContractChange?.forEach((e) => {
      formData.append('ReqFileContractChange', e)
    })

    tableSelected?.forEach((e) => {
      formData.append('OtherAttachs', e)
    })

    delFiles?.forEach((e) => {
      formData.append('DelAttachs', e)
    })

    console.log('data.contractorFile : ', data.contractorFile)

    data.contractorFile
      ?.filter((e) => e.file)
      ?.forEach((e, index) => {
        formData.set(`NewAttachs[${index}].File`, e.file.blobFile)
        formData.set(`NewAttachs[${index}].Type`, e.contractFileTypeId)
      })

    handleCallService(formData, projectId, data?.saveContractChange)
  }

  const onDeleteFile = (id) => {
    setDelFiles([...delFiles, id])
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}
      <Panel
        shaded
        header={formSchema.header}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {!isRefash && (
          <>
            <CenterChangeFormInfo schema={formSchema} />

            {formSchema?.contractChangeFormInfo?.statusCode != 4 && (
              <>
                {!formSchema.disable ? (
                  <CenterChangeFormForm
                    schema={formSchema.inputForm}
                    isEContract={formSchema.botton?.isEContract}
                    attachFiles={formSchema.contractChangeAttachment}
                    attachForm={formSchema.attachForm}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    onSelectOption={setOptionSelected}
                    setTableSelected={setTableSelected}
                    // gettableSelected={tableSelected}
                    onDeleteFile={onDeleteFile}
                  />
                ) : (
                  <CenterChangeFormView
                    schema={formSchema.inputForm}
                    isEContract={formSchema.botton?.isEContract}
                    attachFiles={formSchema.contractChangeAttachment}
                    attachForm={formSchema.attachForm}
                  />
                )}
              </>
            )}

            {formSchema.botton && (
              <div style={{ textAlign: 'right' }}>
                <hr />
                {optionSelected != 1 &&
                  optionSelected != 4 &&
                  formSchema.botton.downloadCompleateFile && (
                    <DownloadButton
                      style={{
                        marginRight: 10,
                        marginBottom: 10,
                      }}
                      disabled={!formSchema.contractChangeFormInfo?.complatePathFile || isLoading}
                      onClick={() => {
                        handleDownloadEContractFile(
                          formSchema.contractChangeFormInfo?.complatePathFile
                        )
                      }}
                    >
                      {formSchema.botton.downloadCompleateFile}
                    </DownloadButton>
                  )}

                {optionSelected != 1 && optionSelected != 4 && formSchema.botton.downloadFile && (
                  <ViewButton
                    style={{
                      marginRight: 10,
                      marginBottom: 10,
                    }}
                    icon="print"
                    disabled={isLoading}
                    onClick={() => {
                      handleDownloadFile()
                    }}
                  >
                    {formSchema.botton.downloadFile}
                  </ViewButton>
                )}

                {formSchema.botton.save && (
                  <SaveButton onClick={handleSubmit(onSubmit)} disabled={isLoading}>
                    {formSchema.botton.save}
                  </SaveButton>
                )}

                {optionSelected == '3' && formSchema.botton.sendToSign && (
                  <SaveButton
                    icon="send"
                    disabled={isLoading}
                    onClick={() => {
                      setIsConfimSendSign(true)
                    }}
                  >
                    {formSchema.botton.sendToSign}
                  </SaveButton>
                )}
                {formSchema.botton.cancel && (
                  <CancelButton
                    onClick={() => {
                      history.push(pathname.proposal.overview.overviewCoworker)
                    }}
                  >
                    {formSchema.botton.cancel}
                  </CancelButton>
                )}
              </div>
            )}
          </>
        )}

        <ConfirmWidget
          title={`ยืนยัน`}
          show={isConfimSendSign}
          detail={<p>ยืนยันส่งลงนาม E-Sign</p>}
          onCancle={() => {
            setIsConfimSendSign(false)
          }}
          onConfirm={() => {
            handleSendToSign()
            setIsConfimSendSign(false)
          }}
        />
      </Panel>

      {/* {formSchema.attachFilesPaperType && optionSelected == '2' && ( */}
      {formSchema?.inputForm?.saveContractChange?.value == '2' &&
        optionSelected == '2' &&
        formSchema?.attachFilesPaperType && (
          <AttachFilesPaperTypeForm
            schemaAttachFiles={formSchema?.attachFilesPaperType}
            buttonAtt={formSchema.botton}
            contractChangeId={formSchema.contractChangeFormInfo?.contractChangeId}
          />
        )}
    </>
  )
}
